import httpService from '@/core/http-service'

function getMessages(errandId) {
  return httpService.get(`errands/${errandId}/messages`)
}

function postMessage(errandId, data) {
  return httpService.post(`errands/${errandId}/messages`, data)
}

export default { getMessages, postMessage }
